// extracted by mini-css-extract-plugin
module.exports = {"footer":"footerWidget_footer__3Y18o"};